(() => {
  'use strict';
  function initialise(root) {
    if (!root || root.hasAttribute('data-ss-home-schedule') || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    const update = () => {
      const now = Date.now() / 1000;
      const start = Number(root.dataset.start), end = Number(root.dataset.end);
      const active = root.dataset.enabled === 'true' && Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
      root.querySelectorAll('[data-ss-offer]').forEach(node => { node.hidden = !active; });
      root.querySelectorAll('[data-ss-regular]').forEach(node => { node.hidden = active; });
      root.querySelectorAll('[data-ss-main-cta]').forEach(link => {
        const label = link.querySelector('[data-ss-cta-label]');
        if (label && link.dataset.hasCart !== 'true') label.textContent = active ? `Shop with ${root.dataset.percent}% off` : 'Find your piece';
      });
    };
    update();
    const timer = window.setInterval(() => { if (!root.isConnected) { window.clearInterval(timer); return; } update(); }, 60000);
  }
  document.querySelectorAll('[data-ss-landing]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-ss-landing]').forEach(initialise); });
})();


